import React from 'react';

import { useStyles } from './styles';
import AssignmentTurnedInOutlinedIcon from '@material-ui/icons/AssignmentTurnedInOutlined';

const FormSubmitted = () => {
    const classes = useStyles();

    return (
        <div className={classes.formSubmittedContainer}>
            <div className={classes.formSubmittedTitle}>Thank you for your submission.</div>
            <div className={classes.formSubmittedSubtitle}>Your response has been recorded.</div>
            <div className={classes.formSubmittedIconContainer}>
                <AssignmentTurnedInOutlinedIcon classes={{ root: classes.formSubmittedIcon }} />
            </div>
        </div>
    );
};

export default FormSubmitted;
